<template>
  <div>
    <video ref="videojs" id="video-item" class="video-js"></video>
  </div>
</template>

<script>
export default {
  name: "videojs-player",
  props: {
    tech: String,
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
      previousSegmentError: 0,
    };
  },
  mounted() {
    const vm = this;
    if(this.tech === 'hlsjs') {
      let hls = require('videojs-hlsjs-plugin');
      hls.register(videojs);
      vm.options['html5']['hlsjsConfig'] = {
        debug: this.$route.query.debug === "true" || "false"
      }
    }
    videojs(vm.$refs.videojs, vm.options).
      ready(function() {
        vm.player = this;
        this.reloadSourceOnError({ errorInterval: 5 });
        this.hotkeys({ volumeStep: 0.05, seekStep: 10, enableModifiersForNumbers: false });

        // In theory v-on="$listeners" should work, but in practice it doesn't seem to (fully) work.
        // Instead, manually propagate the events we care about.
        this.on(["loadedmetadata", "ready", "progress", "timeupdate", "ended", "play", "error"], function(ev) {
          vm.$emit(ev.type, ev);
        });
      });
    window.addEventListener("segment-error", vm.skipSegment.bind(vm));
  },
  methods: {
    // This works with a patched videojs (specifically http-streaming or VHS). It has been patched
    // to emit a `segment-error` event on the window when it finds a 0 byte segment. We listen for
    // that error here and skip ahead 6 seconds (should be the next segment).
    //
    // The patched http-streaming library is on Github at @cloudapp/http-streaming -- the minified
    // video.js build (JS+CSS) is in this repo, under `vendor/assets/`
    skipSegment: function() {
      const time = this.player.currentTime();
      if (time == this.previousSegmentError) {
        this.player.currentTime(time + 6); // TARGETDURATION is 6, so this should skip to the next segment
      }
      this.previousSegmentError = time;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped lang="scss">
.video-item {
  width: auto;
  height: "100%";
  background-color: transparent;

  .vjs-poster {
    background-position: center;
    background-color: transparent;
  }
}
</style>
